import { NamedView } from "@common/types/views/views";
import { TransactionView } from "@common/types/views/transactionViews";
import { createDefaultTransactionView } from "./DefaultTransactionView";

export const UNRECONCILED_CHECKS_VIEW_ID = "unreconciled-checks";

interface CreateUnreconciledChecksViewOptions {
    entityIds: number[];
    hasAnyClass: boolean;
    isGlFirst: boolean;
}

export const createUnreconciledChecksView = ({
    entityIds,
    hasAnyClass,
    isGlFirst,
}: CreateUnreconciledChecksViewOptions): NamedView<TransactionView> => ({
    ...createDefaultTransactionView({ entityIds, hasAnyClass, isGlFirst }),
    id: UNRECONCILED_CHECKS_VIEW_ID,
    name: "Checks review",
    filters: {
        entityIds,
        isUnreconciledCheck: true,
    },
});
